export const dbFields =
{
    imei: {
        visiable: false,
        title: 'Imei',
        key: 'imei'
    },
};
